import { Navigate, Route, Routes } from 'react-router-dom';

import { GlobalRedirect } from '@amzn/sss-website-theme';

import { AcpsCreditsClientProvider } from 'src/clients/acps/AcpsCreditsClientProvider';
import { isStorefrontListingEnabled } from 'src/clients/weblab/weblab-client';
import { ROUTES } from 'src/enums/Routes';

import { CheckoutPage } from './pages/checkout/CheckoutPage';
import { CommitmentsFormPage } from './pages/intake-form/pages/CommitmentsFormPage';
import { InformationFormPage } from './pages/intake-form/pages/InformationFormPage';
import { IntakeFormPage } from './pages/intake-form/pages/IntakeFormPage';
import { ProductDetailPage } from './pages/product-detail/ProductDetailPage';
import { LowerCarbonFuelsPage } from './pages/segment/lower-carbon-fuels/LowerCarbonFuelsPage';
import { ReduceDeforestationPage } from './pages/segment/reduce-deforestation/ReduceDeforestationPage';
import { RestoringForestsPage } from './pages/segment/restoring-forests/RestoringForestsPage';
import { SuperpollutantsPage } from './pages/segment/superpollutants/SuperpollutantsPage';
import { TechCarbonRemovalPage } from './pages/segment/tech-carbon-removal/TechCarbonRemovalPage';
import { SignInPage } from './pages/sign-in/SignInPage';
import { StorePage } from './pages/store/StorePage';

export const PageRoutes = () => (
  <Routes>
    {/* ===== CREDITS SECTION ===== */}
    <Route
      path={ROUTES.PRODUCT_PAGE}
      element={
        <AcpsCreditsClientProvider>
          <ProductDetailPage />
        </AcpsCreditsClientProvider>
      }
    />
    <Route path={ROUTES.CHECKOUT_PAGE} element={<CheckoutPage />} />

    {/* Redirect /credits/storefront to /credits/store when storefront listing weblab is enabled */}
    {isStorefrontListingEnabled && (
      <Route path={ROUTES.CREDITS_STOREFRONT} element={<Navigate to={ROUTES.CREDITS_STORE} replace />} />
    )}

    {/* ===== CREDITS SEGMENTS SECTION ===== */}
    {isStorefrontListingEnabled && (
      <Route
        path={ROUTES.CREDITS_STORE}
        element={
          <AcpsCreditsClientProvider>
            <StorePage />
          </AcpsCreditsClientProvider>
        }
      />
    )}
    <Route path={ROUTES.CREDITS_SEGMENT_REDUCE_DEFORESTATION} element={<ReduceDeforestationPage />} />
    <Route path={ROUTES.CREDITS_SEGMENT_RESTORING_FORESTS} element={<RestoringForestsPage />} />
    <Route path={ROUTES.CREDITS_SEGMENT_TECH_CARBON_REMOVAL} element={<TechCarbonRemovalPage />} />
    <Route path={ROUTES.CREDITS_SEGMENT_SUPERPOLLUTANTS} element={<SuperpollutantsPage />} />
    <Route path={ROUTES.CREDITS_SEGMENT_LOWER_CARBON_FUELS} element={<LowerCarbonFuelsPage />} />

    {/* ===== CREDITS INTEREST INTAKE SECTION ===== */}
    <Route path={ROUTES.CREDITS_INTEREST_PAGE} element={<Navigate to={ROUTES.INTAKE_PAGE} replace />} />
    <Route path={ROUTES.INTAKE_PAGE} element={<IntakeFormPage />}>
      <Route path={ROUTES.INTAKE_PAGE_STEP_1} element={<InformationFormPage />} />
      <Route path={ROUTES.INTAKE_PAGE_STEP_2} element={<CommitmentsFormPage />} />
    </Route>

    {/* Account routes now served by AsxMyAccountWebsite — redirect via Mons */}
    <Route path="/account/*" element={<GlobalRedirect to="/account" />} />

    {/* Sign in page for mons auth portal redirects */}
    <Route path={ROUTES.SIGN_IN_PAGE} element={<SignInPage />} />

    {/* catch all for pages not found */}
    <Route path="*" element={<GlobalRedirect to={ROUTES.NOT_FOUND} />} />
  </Routes>
);
